import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  creditPricing: [],
  step: 1,
};

export const creditsSlice = createSlice({
  name: "credits",
  initialState: initialState,
  reducers: {
    getStep: (state, action) => {
      state.step = action.payload;
    },
    getCreditsPricing: (state, action) => {
      state.creditPricing = action.payload;
    },
  },
});

export const selectCreditsPricing = (state) => state.credits.creditPricing;
export const selectStep = (state) => state.credits.step;

export const { getStep, getCreditsPricing } = creditsSlice.actions;
export default creditsSlice.reducer;
